import React from "react";
import { Select } from "antd";
import { OperatorSelectorProps } from "react-querybuilder";

export const CustomOperatorSelector: React.FC<OperatorSelectorProps> = (props) => {
    const { handleOnChange, value, options, rule } = props;
    return (
        <Select
            disabled={!!rule?.disabled}
            value={value}
            style={{ width: 200 }}
            placeholder="Select operator"
            onChange={(selectedValue) => {
                handleOnChange(selectedValue);
            }}
            options={
                options?.map((option: any) => ({
                    value: option?.name,
                    label: option?.label,
                })) ?? []
            }
        />
    );
};
